import React from "react";
import { useCurrency } from "@/lib/currency";
import { CurrencyCircleDollar, CaretDown } from "@phosphor-icons/react";

const FLAG_URLS = {
  INR: "https://flagcdn.com/24x18/in.png",
  USD: "https://flagcdn.com/24x18/us.png",
  GBP: "https://flagcdn.com/24x18/gb.png",
};

export default function CurrencySwitcher({ compact = false }) {
  const { code, change, options } = useCurrency();

  // Cycle to next currency (used by the mobile single-chip view)
  const cycleNext = () => {
    if (!options || options.length < 2) return;
    const idx = options.indexOf(code);
    const next = options[(idx + 1) % options.length];
    change(next);
  };

  return (
    <div className={`md-currency-switcher ${compact ? "compact" : ""}`} data-testid="currency-switcher">
      <CurrencyCircleDollar size={14} weight="duotone" className="md-currency-globe" />

      {/* Desktop / tablet: full chip row */}
      {options.map((c) => (
        <button
          key={c}
          onClick={() => change(c)}
          className={`md-currency-chip md-currency-chip-full ${code === c ? "active" : ""}`}
          data-testid={`currency-${c}`}
          aria-label={`Switch to ${c}`}
        >
          <img src={FLAG_URLS[c]} alt={`${c} flag`} className="md-currency-flag" width={16} height={12} loading="lazy" />
          {c}
        </button>
      ))}

      {/* Mobile: single chip that cycles forward on tap */}
      <button
        type="button"
        onClick={cycleNext}
        className="md-currency-chip md-currency-chip-mobile active"
        data-testid="currency-mobile-toggle"
        aria-label={`Current currency ${code}, tap to switch`}
      >
        <img src={FLAG_URLS[code]} alt={`${code} flag`} className="md-currency-flag" width={16} height={12} loading="lazy" />
        {code}
        <CaretDown size={10} weight="bold" />
      </button>
    </div>
  );
}
